(function() { window.GUID_4b18b079_4c0b_4063_8880_276fbfada1ad = { getGuid: function() { return "4b18b079-4c0b-4063-8880-276fbfada1ad"; } }; })();
var bracketBoxes = null;
var actualFlowBlockId = null;
var actualFlowBlockIsBracket = null;
var flowBlocksSearch = null;
var entityPopupClicked = false;
var entityPopup = null;
var schedulePopup = null;
var canvasChart = $('#CanvasChart');
var zoomCanvas = new CS.CSZoomCanvas(canvasChart);
var masterContainerOverEverything = $('#MasterContainerOverEverything');
var btnPrintBracket = $('#BtnPrintBracket');
var btnEmbedBracket = $('#BtnEmbedBracket');
var selectedFlowBlockId = $('#HiddenFlowBlockId');
var btnEditRRBSchedule = $('#BtnEditRRBSchedule');
var btnAddEntity = $('#BtnAddEntity');
var btnByeSequence = $('#BtnByeSequence');
var btnCSRDistribution = $('#BtnCSRDistribution');
if (selectedFlowBlockId.length > 0 && selectedFlowBlockId.val() != "") {
    OnFlowBlockChange(selectedFlowBlockId.val());
}
var treeViewDivisionsCharts;
CS.on('TreeViewIsLoaded', '#TreeViewDivisionsCharts', function (e, treeView) {
    treeViewDivisionsCharts = treeView;
    treeViewDivisionsCharts.TreeViewItemSelected = function (treeViewItem) {
        OnFlowBlockChange(treeViewItem.data('id'));
    };
});
btnCSRDistribution.on('click', 'a', function (e) {
    e.preventDefault();
    if (actualFlowBlockId != null && actualFlowBlockId != "") {
        window.open(CSParameters.RUrl + 'CSRLookup/DivisionCsrLookup/' + CSParameters.SportEventId + '?FlowBlockId=' + actualFlowBlockId, "_blank");
    }
});
btnPrintBracket.on('click', 'a', function (e) {
    e.preventDefault();
    if (actualFlowBlockId != null && actualFlowBlockId != "") {
        this.target = "_blank";
        var reportParam = "?FlowBlockId=" + actualFlowBlockId;
        window.open(CSParameters.RUrl + "Charts/PrintBracket/" + CSParameters.SportEventId + reportParam);
    }
});
btnEmbedBracket.on('click', 'a', function (e) {
    e.preventDefault();
    if (actualFlowBlockId != null && actualFlowBlockId != "" && actualFlowBlockId != "0") {
        var data = {
            flowBlockId: actualFlowBlockId
        };
        CompuSport.Ajax.Get(CSParameters.BaseUrl + "Charts/GetChartEmbbededString/" + CSParameters.SportEventId, data, function (result) {
            CompuSport.Controls.Popup.ShowWarningDialog(result);
        });
    }
});
var actualEncounterInfos = {
    FlowBlockId: null,
    EncounterRowId: null,
    EncounterNumber: null,
    StartDate: null,
    SurfaceName: null,
    Discriminator: null,
    OppPos0: null,
    OppPos1: null,
    DrawBoxWithFocus: null,
    OppId0: null,
    OppName0: null,
    DrawPosition0: null,
    OppId1: null,
    OppName1: null,
    DrawPosition1: null,
    OppIdFocus: null,
    OppNameFocus: null,
    IsFakeEncounter: null,
    FlowBlockIdSource: null,
    DrawPositionSources: null,
    EncounterNumberSource: null,
    WinnerFlowBlockIdDest: null,
    WinnerDrawPositionDest: null,
    LocalWinnerDrawPositionDest: null,
    LooserFlowBlockIdDest: null,
    LooserDrawPositionDest: null,
    LocalLooserDrawPositionDest: null
};
var lastHighlight = { DrawBoxFocus: null, ScheduleBoxFocus: null, Source1: null, Source2: null, Looser: null, Winner: null, EditControls: null, EntityPath: null, LocalLooser: null, LocalWinner: null };
function HiglightBracketBoxesCorrespondingText(textSearch) {
    if (bracketBoxes != null) {
        $.each(bracketBoxes, function (index, box) {
            for (var i = 0; i < box.children.length; i++) {
                var text = box.children[i].innerHTML.toUpperCase();
                if (text.indexOf(textSearch) > -1 && textSearch.length > 0) {
                    $(box).addClass('Hglrdonly');
                    break;
                }
                else {
                    $(box).removeClass('Hglrdonly');
                }
            }
        });
    }
}
CS.doc.on('mouseup.chart', function () {
    if (!entityPopupClicked) {
        HideEntityPopup();
    }
    entityPopupClicked = false;
    if (flowBlocksSearch != null) {
        flowBlocksSearch.hide();
    }
});
function OnFlowBlockChange(flowBlockId) {
    btnPrintBracket.addClass('IsDisabled');
    btnEmbedBracket.addClass('IsDisabled');
    btnCSRDistribution.addClass('IsDisabled');
    btnEditRRBSchedule.addClass('IsDisabled');
    btnAddEntity.addClass('IsDisabled');
    btnByeSequence.addClass('IsDisabled');
    if (flowBlockId == null) {
        flowBlockId = treeViewDivisionsCharts.SelectedValue();
    }
    /*if (flowBlockId != null && flowBlockId.indexOf('FlowBlock_') != -1) {
        flowBlockId = flowBlockId.replace('FlowBlock_', '');
    }*/
    selectedFlowBlockId.val(flowBlockId);
    if (treeViewDivisionsCharts != null) {
        if (treeViewDivisionsCharts.SelectedValue() == null && flowBlockId == null) {
            return;
        }
    }
    var data = {};
    data.flowBlockId = flowBlockId;
    data.CustomParams = $('#CustomParams').val();
    data.highlightedEntityBaseId = null;
    data.highlightedDrawPosition = null;
    var linkerMode = false;
    var linkerModePassed = $('#LinkerMode').val();
    if (linkerModePassed != undefined) {
        linkerMode = linkerModePassed;
    }
    data.linkerMode = linkerMode;
    CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/Chart/" + CSParameters.SportEventId, data, function (queryResult) {
        masterContainerOverEverything.slideDown(250, function () {
            UpdateChart(queryResult, false);
            actualFlowBlockId = data.flowBlockId;
            if (actualFlowBlockId != null && actualFlowBlockId != "" && actualFlowBlockId != "0") {
                btnPrintBracket.removeClass('IsDisabled');
                btnEmbedBracket.removeClass('IsDisabled');
                btnCSRDistribution.removeClass('IsDisabled');
            }
            else {
                RefreshToolBarButtons();
            }
        });
    });
}
function UpdateChart(result, updateOnlyHtml) {
    var splitResuls = result.split("|;|");
    if (splitResuls.length > 1) {
        result = splitResuls[0];
        var selectedFlowBlockd = splitResuls[1];
        if (IsDefined(typeof (treeViewDivisionsCharts))) {
            treeViewDivisionsCharts.SelectTreeViewItemByData('id', "FlowBlock_" + selectedFlowBlockd);
        }
    }
    $('#ChartInfos').remove();
    $('#EntityPopup').remove();
    $('#SchedulePopup').remove();
    document.CanvasChart.ShowHideContent(true);
    document.CanvasChart.LoadNewContent(result, updateOnlyHtml, function () {
        var actualChartInfo = $('#ChartInfos', document.CanvasChart.CanvasContentEdge);
        entityPopup = $('#EntityPopup', document.CanvasChart.CanvasContentEdge);
        schedulePopup = $('#SchedulePopup', document.CanvasChart.CanvasContentEdge);
        actualChartInfo.detach().appendTo('#MasterContainerOverEverything');
        entityPopup.detach().appendTo('#MasterContainerOverEverything');
        schedulePopup.detach().appendTo('#MasterContainerOverEverything');
        actualFlowBlockId = document.CanvasChart.CanvasContentEdge.data('flowblockid');
        actualFlowBlockIsBracket = document.CanvasChart.CanvasContentEdge.data('isbracket');
        BindChartEvents();
        if (IsDefined(typeof (RefreshToolBarButtons))) {
            RefreshToolBarButtons();
        }
        var focusedBox = $('#Bracket .Focus');
        var focusedGame = $('#Bracket .SB').filter(function () {
            return $(this).hasClass('SEL') || $(this).find('.BB.SEL').length > 0;
        });
        if (focusedBox.length > 0) {
            document.CanvasChart.ScaleTo(15, function () {
                document.CanvasChart.CenterElement(focusedBox, function () {
                    document.CanvasChart.ShowHideContent(false);
                    if (IsDefined(typeof (CS.docHtml))) {
                        CS.docHtml.trigger('panelopened', document.CanvasChart.CanvasId);
                    }
                });
            });
        }
        else if (focusedGame.length > 0) {
            let gameBoxHeight = parseInt(focusedGame.attr('style').match("height:(.*)?em;")[1]);
            let zoomFocus = 9.5e-5 * Math.pow(gameBoxHeight, 2) - 0.1 * gameBoxHeight + 15;
            document.CanvasChart.ScaleTo(zoomFocus, function () {
                document.CanvasChart.CenterElement(focusedGame, function () {
                    document.CanvasChart.ShowHideContent(false);
                    if (IsDefined(typeof (CS.docHtml))) {
                        CS.docHtml.trigger('panelopened', document.CanvasChart.CanvasId);
                    }
                });
            });
        }
        else {
            document.CanvasChart.ShowHideContent(false);
            if (IsDefined(typeof (CS.docHtml))) {
                CS.docHtml.trigger('panelopened', document.CanvasChart.CanvasId);
            }
        }
    });
    document.CanvasChart.Canvas.off('RefreshContent');
    document.CanvasChart.Canvas.on('RefreshContent', function () {
        var data = {};
        data.flowBlockId = actualFlowBlockId;
        data.highlightedEntityBaseId = null;
        data.highlightedDrawPosition = null;
        CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/Chart/" + CSParameters.SportEventId, data, function (queryResult) {
            UpdateChart(queryResult, true);
        });
    });
}
function BindChartEvents() {
    var goBack = $('#ClickHereToGoBack', document.CanvasChart.CanvasContentEdge);
    if (goBack != null && goBack.length > 0) {
        var fromflowblockid = goBack.data('fromflowblockid');
        goBack.on('click', function () {
            var data = {};
            data.flowBlockId = fromflowblockid;
            data.fromFlowBlockId = null;
            data.highlightedEntityBaseId = null;
            data.highlightedDrawPosition = null;
            CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/Chart/" + CSParameters.SportEventId, data, function (result) {
                UpdateChart(result, false);
            });
        });
    }
    if (actualFlowBlockIsBracket == "True") {
        BindBracketEvents(document.CanvasChart.CanvasContentEdge);
        btnEditRRBSchedule.hide();
        btnAddEntity.hide();
        btnByeSequence.show();
        btnByeSequence.removeClass('IsDisabled');
    }
    else {
        CrossTable.desktop.BindCrossTableEvents(document.CanvasChart.CanvasContentEdge);
        btnEditRRBSchedule.show();
        btnAddEntity.show();
        btnAddEntity.removeClass('IsDisabled');
        btnByeSequence.hide();
    }
}
//Est appelé de Bracket.js ou de CrossTable.js
function GetEntityPopup(entityBaseId, drawPosition, onLeft, callback) {
    var data = {};
    data.flowBlockId = actualFlowBlockId;
    data.entityBaseId = entityBaseId;
    data.drawPosition = drawPosition;
    CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/GetEntityPopup/" + CSParameters.SportEventId, data, function (result) {
        ShowEntityPopup(result, onLeft, callback);
    });
}
function ShowEntityPopup(result, onLeft, callback) {
    if (onLeft) {
        entityPopup.addClass('OnLeft');
    }
    else {
        entityPopup.removeClass('OnLeft');
    }
    entityPopup.html(result);
    entityPopup.off('mousedown');
    entityPopup.on('mousedown', function () {
        entityPopupClicked = true;
    });
    entityPopup.slideDown(50);
    var encounterInfos = JSON.parse($('#EncounterInfos').val());
    OnEncounterInfoOfBracketObtain(encounterInfos, callback);
}
function HideEntityPopup() {
    if (entityPopup != null) {
        entityPopup.slideUp(50);
    }
}

//# sourceMappingURL=Chart.desktop.js.map
